import { useEffect, useState } from "react";

export interface MyPlace {
  id: string;
  name: string;
}

interface Mine {
  places: MyPlace[];
  /** my private place lists (docs/plans/buttons-and-place-lists.md, part 3) */
  lists: MyPlace[];
}
const NONE: Mine = { places: [], lists: [] };
let cache: Promise<Mine> | null = null;

/**
 * My private places and place lists (P1), for the place pickers of a shared space: they live in my own space,
 * which a shared space's doc does not contain. Fetched once per page load.
 */
export function useMyPlaces(enabled: boolean): Mine {
  const [mine, setMine] = useState<Mine>(NONE);
  useEffect(() => {
    if (!enabled) return;
    cache ??= fetch("/api/internal/places/mine", { credentials: "same-origin" })
      .then((r) => (r.ok ? r.json() : NONE))
      .then((b: Partial<Mine>) => ({ places: b.places ?? [], lists: b.lists ?? [] }))
      .catch(() => NONE);
    let live = true;
    void cache.then((m) => live && setMine(m));
    return () => {
      live = false;
    };
  }, [enabled]);
  return enabled ? mine : NONE;
}

/** Place ids are ULIDs; an id that is not in my lists is someone else's private place. */
export const looksLikePlaceId = (v: string) => /^[0-9A-HJKMNP-TV-Z]{26}$/.test(v);
